module.exports = __webpack_public_path__ + "img/logo_cesa_gris.292ca3ba.png";